import React from 'react';
import styled from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const MATERIALS_ICON_GRADIENT = 'materialBoardsGradient';

const MaterialsIconSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.86768 5.24697C3.86768 3.81103 5.03174 2.64697 6.46768 2.64697H17.5323C18.9682 2.64697 20.1323 3.81103 20.1323 5.24697V16.0414C20.1323 17.0982 19.2756 17.9549 18.2188 17.9549H12.7175L12.716 17.9547H6.87933C6.27289 17.9547 5.78128 18.4463 5.78128 19.0527C5.78128 19.6592 6.27289 20.1508 6.87933 20.1508H19.1757C19.7041 20.1508 20.1324 20.5791 20.1324 21.1075C20.1324 21.6359 19.7041 22.0643 19.1757 22.0643H6.87933C5.22063 22.0643 3.87514 20.7233 3.86782 19.0663L3.86768 19.0665V5.24697ZM7.21617 8.86554C7.21617 8.33715 7.64452 7.9088 8.17291 7.9088H15.8269C16.3552 7.9088 16.7836 8.33715 16.7836 8.86554C16.7836 9.39394 16.3552 9.82228 15.8269 9.82228H8.17291C7.64452 9.82228 7.21617 9.39394 7.21617 8.86554Z"
      />
      <defs>
        <linearGradient
          id={MATERIALS_ICON_GRADIENT}
          x1="14.4159"
          y1="25.1739"
          x2="5.46261"
          y2="2.64697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FB6C25" />
          <stop offset="1" stopColor="#FFCE2D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MaterialsIconSvg;

const SPath = styled.path`
  fill: #a5aac5;

  ${onLightTheme`
    fill: rgb(var(--ln-content) / 0.6);
  `}

  .active & {
    fill: url(#${MATERIALS_ICON_GRADIENT});
  }
`;
